<template>
    <b-nav-item-dropdown v-if="instruments.length" class="instruments-menu">
        <template v-slot:button-content>
            <span>
                {{ $translate('instrument') }} {{ activeInstrumentId }} (
                <slides-count
                    :slides="activeInstrument.slides"
                    :instrument-type="activeInstrument.type"
                />)
            </span>
        </template>

        <b-dropdown-item
            v-for="option in dropdownOptions"
            :key="option.esId"
            :to="{
                name: $route.name,
                query: { ...$route.query, instrument: option.esId }
            }"
        >
            {{ $translate('instrument') }} {{ option.esId }} (<slides-count
                :slides="option.slides"
                :instrument-type="option.type"
            />)
        </b-dropdown-item>
    </b-nav-item-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import SlidesCount from '../common/SlidesCount'

export default {
    name: 'InstrumentsMenu',
    components: { SlidesCount },
    computed: {
        ...mapState({
            instruments: state => state.timelapse.instruments
        }),
        dropdownOptions() {
            return this.instruments.filter(
                instrument => instrument.esId !== this.activeInstrumentId
            )
        },
        activeInstrumentId() {
            const { query } = this.$route

            return query.instrument || this.instruments[0].esId
        },
        activeInstrument() {
            return this.instruments.find(instr => instr.esId === this.activeInstrumentId)
        }
    },
    mounted() {
        const { query } = this.$route

        if (!query.instrument) {
            this.$router.replace({
                name: this.$route.name,
                query: { ...this.$route.query, instrument: this.instruments[0].esId }
            })
        }
    }
}
</script>

<style lang="scss">
.instruments-menu {
    .dropdown-menu {
        background-color: $dark-6;

        .dropdown-item,
        .dropdown-item.active,
        .dropdown-item:active {
            padding: 0.25rem 0.5rem;
            background-color: $dark-6;
        }

        a {
            text-decoration: none;
        }
    }
}
</style>
